import { gql } from 'graphql-tag';

/**
 * Contains pagination info used across all paginated queries in graphQL.
 */
export const pageInfoFragment = gql`
  fragment PageInfo on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
`;
